import React from 'react';

function SearchIcon({ className = 'w-4 h-4' }) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path fillRule="evenodd" d="M9 3a6 6 0 104.472 10.03l2.249 2.249a1 1 0 001.414-1.414l-2.249-2.249A6 6 0 009 3zm-4 6a4 4 0 118 0 4 4 0 01-8 0z" clipRule="evenodd" />
    </svg>
  );
}

export default function ModulesSearchInput({
  value,
  onChange,
  onKeyDown,
  inputRef,
  placeholder = 'Rechercher un module…',
}) {
  return (
    <div className="relative w-full sm:w-[280px]">
      <span className="absolute inset-y-0 left-3 flex items-center text-gray-400 dark:text-gray-500 pointer-events-none">
        <SearchIcon />
      </span>
      <input
        ref={inputRef}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        className={[
          'w-full',
          'h-9',
          'pl-9 pr-3',
          'rounded-lg',
          'border border-gray-200/80 dark:border-gray-800/80',
          'bg-white/70 dark:bg-gray-900/60',
          'text-sm text-gray-900 dark:text-white',
          'placeholder:text-gray-400 dark:placeholder:text-gray-500',
          'outline-none',
          'focus:ring-2 focus:ring-blue-500/40 focus:border-blue-500/40',
          'transition-shadow',
        ].join(' ')}
        autoComplete="off"
        inputMode="search"
      />
    </div>
  );
}

